// Service para gerenciamento de pedidos
import api from './api';

export const pedidoService = {
  // Buscar todos os pedidos
  getAll: async (filters = {}, page = 1, limit = 10) => {
    try {
      const params = {
        page,
        limit
      };
      
      Object.keys(filters).forEach(key => {
        if (filters[key] && filters[key] !== '') {
          params[key] = filters[key];
        }
      });

      const response = await api.get('/pedidos', { params });
      
      return { 
        data: response.data?.data?.pedidos || response.data?.pedidos || response.data || [], 
        success: true,
        pagination: response.data?.data?.pagination || response.data?.pagination
      };
    } catch (error) {
      console.error('Erro ao buscar pedidos:', error);
      return { data: [], success: false, error: error.message };
    }
  },

  // Buscar pedido por ID
  getById: async (id) => {
    try {
      const response = await api.get(`/pedidos/${id}`);
      return { data: response.data?.data || response.data, success: true };
    } catch (error) {
      console.error('Erro ao buscar pedido:', error);
      return { data: null, success: false, error: error.message };
    }
  },

  // Buscar itens do pedido
  getItens: async (pedidoId) => {
    try {
      const response = await api.get(`/pedidos/${pedidoId}/itens`);
      return { data: response.data?.data || response.data || [], success: true };
    } catch (error) {
      console.error('Erro ao buscar itens do pedido:', error);
      return { data: [], success: false, error: error.message };
    }
  },

  // Criar novo pedido
  create: async (pedidoData) => {
    try {
      const response = await api.post('/pedidos', pedidoData);
      
      return { 
        data: response.data?.data || response.data, 
        success: true, 
        message: response.data?.message || 'Pedido criado com sucesso' 
      };
    } catch (error) {
      console.error('Erro ao criar pedido:', error.response?.data?.message || error.message);
      
      return { 
        data: null, 
        success: false, 
        error: error.response?.data?.message || error.message,
        validationErrors: error.response?.data?.validationErrors || []
      };
    }
  },

  // Atualizar pedido
  update: async (id, pedidoData) => {
    try {
      const response = await api.put(`/pedidos/${id}`, pedidoData);
      
      return { 
        data: response.data?.data || response.data, 
        success: true, 
        message: response.data?.message || 'Pedido atualizado com sucesso' 
      };
    } catch (error) {
      console.error('Erro ao atualizar pedido:', error.response?.data?.message || error.message);
      
      return { 
        data: null, 
        success: false, 
        error: error.response?.data?.message || error.message,
        validationErrors: error.response?.data?.validationErrors || []
      };
    }
  },

  // Deletar pedido
  deletePedido: async (id) => {
    try {
      const response = await api.delete(`/pedidos/${id}`);
      
      return { 
        success: true, 
        message: response.data?.message || 'Pedido deletado com sucesso' 
      };
    } catch (error) {
      console.error('Erro ao deletar pedido:', error);
      return { 
        success: false, 
        error: error.response?.data?.message || error.message 
      };
    }
  },

  // Buscar pedidos por pessoa
  getByPessoa: async (pessoaId, options = {}) => {
    try {
      const params = {};
      
      if (options.page) params.page = options.page;
      if (options.limit) params.limit = options.limit;

      const response = await api.get(`/pedidos/pessoa/${pessoaId}`, { params });
      
      return { 
        data: response.data?.data?.pedidos || response.data?.pedidos || response.data || [], 
        success: true,
        pagination: response.data?.data?.pagination || response.data?.pagination
      };
    } catch (error) {
      console.error('Erro ao buscar pedidos por pessoa:', error);
      return { data: [], success: false, error: error.message };
    }
  },

  // Buscar opções para selects (pessoas, extensões, etc.)
  getSelectOptions: async () => {
    try {
      // Buscar apenas a API de opções que já existe
      const optionsRes = await api.get('/pedidos/options');
      
      return {
        success: true,
        data: {
          formasEntrega: optionsRes.data?.data?.formasEntrega || [],
          formasPagamento: optionsRes.data?.data?.formasPagamento || [],
          prazosEntrega: optionsRes.data?.data?.prazosEntrega || [],
          // Dados estáticos para produtos e tipos até criar as APIs
          produtos: [
            { value: 1, label: 'Livro - Teologia Sistemática' },
            { value: 2, label: 'Apostila - Homilética' },
            { value: 3, label: 'DVD - Curso de Oratória' },
            { value: 4, label: 'Material Didático - EBD' }
          ],
          tipos: [
            { value: 1, label: 'Livro' },
            { value: 2, label: 'Requerimento' },
            { value: 3, label: 'Material Didático' }
          ],
          extensoes: [
            { value: 1, label: 'CAMPINA GRANDE' },
            { value: 2, label: 'João Pessoa' },
            { value: 3, label: 'Recife' }
          ],
          statusOptions: [
            'Rascunho',
            'Pendente', 
            'Em Andamento',
            'Concluído',
            'Cancelado'
          ]
        }
      };
    } catch (error) {
      console.error('Erro ao buscar opções:', error);
      // Fallback para dados estáticos em caso de erro
      return { 
        success: true,
        data: {
          formasEntrega: [
            { value: 1, label: 'Retirada no IBE' },
            { value: 2, label: 'Entrega na Extensão' }
          ],
          formasPagamento: [
            { value: 1, label: 'Dinheiro' },
            { value: 2, label: 'Cartão de Débito' },
            { value: 3, label: 'Transferência' },
            { value: 4, label: 'PIX' },
            { value: 5, label: 'Gratuito' }
          ],
          prazosEntrega: [
            { value: 1, label: '3 dias' },
            { value: 2, label: '7 dias' },
            { value: 3, label: '15 dias' },
            { value: 4, label: '30 dias' }
          ],
          produtos: [
            { value: 1, label: 'Livro - Teologia Sistemática' },
            { value: 2, label: 'Apostila - Homilética' },
            { value: 3, label: 'DVD - Curso de Oratória' },
            { value: 4, label: 'Material Didático - EBD' }
          ],
          tipos: [
            { value: 1, label: 'Livro' },
            { value: 2, label: 'Requerimento' },
            { value: 3, label: 'Material Didático' }
          ],
          extensoes: [
            { value: 1, label: 'CAMPINA GRANDE' },
            { value: 2, label: 'João Pessoa' },
            { value: 3, label: 'Recife' }
          ],
          statusOptions: [
            'Rascunho',
            'Pendente', 
            'Em Andamento',
            'Concluído',
            'Cancelado'
          ]
        }
      };
    }
  },

  // CRUD para itens do pedido
  
  // Criar item do pedido
  createItem: async (pedidoId, itemData) => {
    try {
      const response = await api.post(`/pedidos/${pedidoId}/itens`, itemData);
      
      return { 
        data: response.data?.data || response.data, 
        success: true, 
        message: response.data?.message || 'Item adicionado com sucesso' 
      };
    } catch (error) {
      console.error('Erro ao criar item:', error);
      return { 
        data: null, 
        success: false, 
        error: error.response?.data?.message || error.message 
      };
    }
  },

  // Atualizar item do pedido
  updateItem: async (pedidoId, itemId, itemData) => {
    try {
      const response = await api.put(`/pedidos/${pedidoId}/itens/${itemId}`, itemData);
      
      return { 
        data: response.data?.data || response.data, 
        success: true, 
        message: response.data?.message || 'Item atualizado com sucesso' 
      };
    } catch (error) {
      console.error('Erro ao atualizar item:', error);
      return { 
        data: null, 
        success: false, 
        error: error.response?.data?.message || error.message 
      };
    }
  },

  // Deletar item do pedido
  deleteItem: async (pedidoId, itemId) => {
    try {
      const response = await api.delete(`/pedidos/${pedidoId}/itens/${itemId}`);
      
      return { 
        success: true, 
        message: response.data?.message || 'Item removido com sucesso' 
      };
    } catch (error) {
      console.error('Erro ao deletar item:', error);
      return { 
        success: false, 
        error: error.response?.data?.message || error.message 
      };
    }
  },

  // Gerar PDF do pedido
  generatePdf: async (pedidoId) => {
    try {
      const response = await api.get(`/pedidos/${pedidoId}/pdf`, {
        responseType: 'blob', // Importante para receber o arquivo como blob
        timeout: 120000 // 2 minutos para geração de PDF
      });
      
      return { 
        data: response.data, 
        success: true,
        headers: response.headers
      };
    } catch (error) {
      console.error('Erro ao gerar PDF:', error);
      
      // Verificar se o erro tem response (erro HTTP)
      if (error.response) {
        console.error('Response status:', error.response.status);
        console.error('Response data:', error.response.data);
        
        return { 
          data: null, 
          success: false, 
          error: error.response?.data?.message || `Erro HTTP ${error.response.status}` || error.message 
        };
      }
      
      // Erro de rede ou outro tipo
      return { 
        data: null, 
        success: false, 
        error: error.message 
      };
    }
  }
};
